import { Table, Space, Button, Modal, Form, Select, Switch, message } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useForm } from 'antd/es/form/Form';
import FormItem from "antd/es/form/FormItem";
import { getMyCompanyUsersAPI, updateUserAttributesAPI } from "@/apis/user";
//用户账号管理
const AccountManage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const { t } = useTranslation();

    const [accountUpdateForm] = useForm()

    const columns = [
        {
            title: t("AccountManage.TableList.UserName"),
            dataIndex: 'username',
            key: 'username'
        },
        {
            title: t("AccountManage.TableList.Power"),
            dataIndex: 'power',
            key: 'power',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.power - b.power,
            render: (v)=>v
        },
        {
            title: t("AccountManage.TableList.Role"),
            dataIndex: 'userRole',
            key: 'userRole',
            filters: [
                {
                    text: 'register',
                    value: 'register',
                },
                {
                    text: 'manager',
                    value: 'manager',
                },
                {
                    text: 'design',
                    value: 'design',
                },
                {
                    text: 'execute',
                    value: 'execute',
                },
            ],
            onFilter: (value, record) => record.userRole.indexOf(value) === 0,
        },
        {
            title: t("AccountManage.TableList.CompanyName"),
            dataIndex: 'companyName',
            key: 'companyName'
        },
        {
            title: t("AccountManage.TableList.CreateTime"),
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: (a, b) => new Date(a.createTime) - new Date(b.createTime),
        },
        {
            title: t("AccountManage.TableList.UpdateTime"),
            dataIndex: 'updateTime',
            key: 'updateTime',
            sorter: (a, b) => new Date(a.updateTime) - new Date(b.updateTime),
        },
        {
            title: 'Designer',
            dataIndex: 'designer',
            key: 'designer',
            render: v => v ? 'Yes' : 'No'
        },
        {
            title: 'Executor',
            dataIndex: 'executor',
            key: 'executor',
            render: v => v ? 'Yes' : 'No'
        },
        {
            title: t('FormList.Action'),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => openEdit(record)}>
                        {t('ButtonList.Update')}
                    </Button>
                </Space>
            )
        },
    ]

    const powerOptions = [
        { value: 0, label: 'init' },
        { value: 1, label: '公司管理员' },
        { value: 2, label: '公司商务' },
        { value: 3, label: '公司执飞人员' },
        { value: 4, label: '公司设计人员' },
    ];

    const openEdit = (record) => {
        setEditingUser(record);
        accountUpdateForm.setFieldsValue({
            power: record.power,
            designer: !!record.designer,
            executor: !!record.executor,
        });
        setIsModalOpen(true);
    }
    const handleCancel = () => {
        setIsModalOpen(false);
        setEditingUser(null);
    };

    async function onUpdateAccountFinish() {
        try {
            const values = await accountUpdateForm.validateFields();
            if(!editingUser) return;
            setLoading(true);
            await updateUserAttributesAPI({
                userId: editingUser.userId,
                power: values.power,
                designer: values.designer ? 1 : 0,
                executor: values.executor ? 1 : 0,
            });
            message.success('更新成功');
            setIsModalOpen(false);
            setEditingUser(null);
            fetchUsers();
        } catch (e) {
            if(!e?.errorFields) message.error('更新失败');
        } finally {
            setLoading(false);
        }
    }

    const fetchUsers = async () => {
        try {
            const res = await getMyCompanyUsersAPI();
            setUserList(Array.isArray(res.data)?res.data:[]);
        } catch (e) {
            message.error('获取账号列表失败');
        }
    };

    useEffect(() => { fetchUsers(); }, []);

    return (
        <div>
            <Table loading={loading} dataSource={userList} columns={columns} rowKey={(record) => record.userId} />
            <Modal open={isModalOpen} onOk={onUpdateAccountFinish} onCancel={handleCancel} confirmLoading={loading} title="编辑用户权限">
                <Form
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    style={{
                        marginTop: 20,
                        maxWidth: 400,
                    }}
                    form={accountUpdateForm}
                >
                    <FormItem name="power" label="权限" rules={[{required:true}]}> 
                        <Select options={powerOptions} />
                    </FormItem>
                    <FormItem name="designer" label="使用设计软件" valuePropName="checked">
                        <Switch />
                    </FormItem>
                    <FormItem name="executor" label="使用地面站" valuePropName="checked">
                        <Switch />
                    </FormItem>
                </Form>
            </Modal>
        </div>
    )
}

export default AccountManage